import { gql } from "@apollo/client"

// Define the mutation
export const UPDATE_SHIFT_STATUS_MUTATION = gql`
    mutation updateShiftHistory($id: MongoID, $record: shiftHistoryRecordInput) {
        updateShiftHistory(_id: $id, record: $record) {
            success
        }
    }
`
